import { render, staticRenderFns } from "./view-expired-service-booking.vue?vue&type=template&id=6137bb17&"
import script from "./view-expired-service-booking.vue?vue&type=script&lang=js&"
export * from "./view-expired-service-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports